import { render, staticRenderFns } from "./MSHD.vue?vue&type=template&id=edc61b9e&scoped=true&"
import script from "./MSHD.vue?vue&type=script&lang=js&"
export * from "./MSHD.vue?vue&type=script&lang=js&"
import style0 from "./MSHD.vue?vue&type=style&index=0&id=edc61b9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc61b9e",
  null
  
)

export default component.exports